<template>
  <div class="IncomeLedger">
    <div class="flex">
      <div class="flex-fixed">
        <div class="inline bold">기간</div>
        <APeriodSelector
          ref="period"
          class="inline ml-default"
          :value="search_period"
          :disabled="disabled"
          hide-select
          @change="handleChangePeriod"
        />
      </div>
      <div class="flex-auto">
        <el-button
          :disabled="disabled || selection.length < 1"
          @click="handleClickTradePrint"
          >거래명세서 인쇄</el-button
        >
        <el-button
          class="ml-default"
          :disabled="disabled || selection.length < 1"
          @click="handleClickListPrint"
          >리스트 인쇄</el-button
        >
        <div class="inline ml-default">
          <el-checkbox v-model="sum_flag">소계 표기</el-checkbox>
        </div>
      </div>
      <div class="flex-fixed rt-area align-right">
        <el-button
          icon="fas fa-file-excel fa-lg"
          style="padding: 8px;"
          :disabled="disabled"
          circle
          @click="handleClickExcel"
        ></el-button>
      </div>
    </div>
    <div class="mt-default">
      <el-row :gutter="10">
        <el-col :span="6">
          <el-input
            class="right c-danger"
            :value="collect_price ? util.addComma(collect_price) : 0"
            readonly
          >
            <template slot="prepend">수금합계</template>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input
            class="right c-danger"
            :value="discount_price ? util.addComma(discount_price) : 0"
            readonly
          >
            <template slot="prepend">DC합계</template>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input
            class="right"
            :value="expense_price ? util.addComma(expense_price) : 0"
            readonly
          >
            <template slot="prepend">판매합계</template>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-input
            class="right c-primary"
            :value="tax_price ? util.addComma(tax_price) : 0"
            readonly
          >
            <template slot="prepend">세액합계</template>
          </el-input>
        </el-col>
      </el-row>
    </div>
    <ATable
      ref="table"
      v-loading="loading"
      max-height="600px"
      :data="items"
      :disabled="disabled"
      :rowClassName="handleRowClassName"
      hide-top-panel
      hide-pagination
      hide-button-insert
      border
      :spanMethod="handleSpanMethod"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        label="선택"
        align="center"
        :width="$width.selection"
        :selectable="selectable"
        fixed
      />
      <el-table-column
        prop="deal_date"
        label="매출일"
        :width="$width.date"
        show-overflow-tooltip
      />
      <el-table-column
        prop="contract_code"
        label="수주번호"
        width="100"
        class-name="contract_code"
        show-overflow-tooltip
      />
      <el-table-column
        prop="product_name"
        label="품목"
        width="200"
        class-name="product_name"
        show-overflow-tooltip
      />
      <el-table-column
        prop="size"
        :label="$t('lang.size')"
        width="100"
        show-overflow-tooltip
      />
      <el-table-column
        prop="pyung"
        label="평"
        width="80"
        show-overflow-tooltip
        :formatter="isGlass"
      />
      <el-table-column
        prop="amount"
        label="수량"
        class-name="cell-number"
        :width="$width.size"
        :formatter="util.numberFormat"
      />
      <el-table-column
        prop="unit_name"
        label="단위"
        class-name="unit_name"
        :width="$width.unit_name"
      />
      <el-table-column
        v-if="isTotalPyung"
        prop="item_pyung"
        label="총평수"
        width="80"
        show-overflow-tooltip
        :formatter="isGlassTotalPyung"
      />
      <el-table-column
        prop="cost"
        label="단가"
        class-name="cell-number cost"
        :width="$width.price"
        :formatter="util.numberFormat"
      />
      <el-table-column
        v-if="showPyungProcessingCost"
        prop="pyung_cost"
        label="평단가"
        class-name="cell-number cost"
        :width="$width.price"
        :formatter="util.numberFormat"
      />
      <el-table-column
        v-if="showPyungProcessingCost"
        prop="item_processing_cost"
        label="가공비"
        class-name="cell-number cost"
        :width="$width.price"
        :formatter="util.numberFormat"
      />
      <el-table-column
        prop="supply_price"
        label="공급가액"
        class-name="cell-number supply_price"
        :width="$width.price"
        :formatter="util.numberFormat"
      />
      <el-table-column
        prop="tax"
        label="세액"
        class-name="cell-number"
        :width="$width.price"
        :formatter="util.numberFormat"
      />
      <el-table-column
        prop="price"
        label="금액"
        class-name="cell-number price"
        :width="$width.price"
        :formatter="util.numberFormat"
      />
      <el-table-column
        prop="balance"
        label="미수금"
        class-name="cell-number balance"
        :width="$width.price"
        :formatter="util.numberFormat"
        show-overflow-tooltip
      />
      <el-table-column
        prop="charger"
        label="담당자"
        :width="100"
        show-overflow-tooltip
      />
      <el-table-column prop="field" label="현장" show-overflow-tooltip />
      <el-table-column prop="desc" label="비고" show-overflow-tooltip />
      <el-table-column
        prop="created_user_name"
        label="등록자"
        :width="$width.username"
      />
      <el-table-column
        prop="modified_user_name"
        label="수정자"
        :width="$width.username"
      />
    </ATable>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      title="거래명세서"
      :visible.sync="dialog_visible"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <IncomeTradePrint
        v-if="dialog_visible"
        :period="period"
        :customer="customer"
        :data="selectedDataTradePrint"
        :sum_flag="sum_flag"
        @completed="handleCompletedTradePrint"
      />
    </el-dialog>
    <el-dialog
      custom-class="form-dialog"
      :width="showPyungProcessingCost ? '1300px' : '1100px'"
      top="0"
      title="거래내역 리스트"
      :visible.sync="dialog2_visible"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <IncomePrint
        v-if="dialog2_visible"
        :period="period"
        :customer="customer"
        :data="selectedData"
        :sum_flag="sum_flag"
        @completed="handleCompletedListPrint"
      />
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { account_form } from "@/common/mixins/account_form";
import { company_info } from "@/common/mixins/company_info";
import IncomeTradePrint from "./IncomeTradePrint";
import IncomePrint from "./IncomePrint";

export default {
  name: "IncomeLedger",
  mixins: [account_form,company_info],
  components: { IncomeTradePrint, IncomePrint },
  data() {
    return {
      company: {
        show_pyung_processing_cost: false,
        income_trade_print_pyung: false,
      },
      title: this.$t("title.sale_ledger"),
      search_period: { value: "1w" },
      period: {},
      loading: false,
      items: [],
      items_original: [],
      collect_price: 0,
      discount_price: 0,
      expense_price: 0,
      tax_price: 0,
      selection: [],
      selectedData: [],
      selectedDataTradePrint: [],
      dialog_visible: false,
      dialog2_visible: false,
      sum_flag: false,
    };
  },
  props: {
    customer: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    customer: function() {
      this.loadData();
    },
    table_config() {
      this.loadConfig()
    },
  },
  computed: {
    ...mapGetters(["table_product", "table_product_category"]),
    showPyungProcessingCost() {
      return this.company.show_pyung_processing_cost;
    },
    isTotalPyung() {
      return this.company.income_trade_print_pyung;
    },
    product_stat() {
      let product_categories = JSON.parse(
        JSON.stringify(this.table_product_category)
      );
      let stat_flag_list = [];
      product_categories.forEach((item) => {
        if (item.stat_flag === "Y") {
          stat_flag_list.push({
            id: stat_flag_list.length + 1,
            label: item.name,
            categories: [item.id],
          });
        }
      });
      return stat_flag_list;
    },
  },
  mounted() {
    this.loadConfig()
  },
  methods: {
    loadData(is_autoselect = true) {
      if (!this.customer) {
        return;
      }
      this.loading = true;
      this.collect_price = 0;
      this.discount_price = 0;
      this.expense_price = 0;
      this.tax_price = 0;
      this.items = [];
      this.api
        .selectIncomeCustomerDate(this.customer.id, this.period.startDate)
        .then((res) => {
          if (res.error !== this.system.noError) {
            this.util.notify_response_error(this, this.title, res);
          }
          this.last_trade = res.data;
          this.api
            .listIncomeCustomer(this.customer.id, this.period)
            .then((res) => {
              this.loading = false;
              if (res.error !== this.system.noError) {
                this.util.notify_response_error(this, this.title, res);
                return;
              }
              this.items_original = res.data;
              this.organizeData(is_autoselect);
            });
        });
    },
    /**
     * 데이터에 소계등을 추가한다.
     */
    organizeData(is_autoselect) {
      let items = Object.assign([], this.items_original);
      let collect_price = 0;
      let discount_price = 0;
      let expense_price = 0;
      let tax_price = 0;
      items.forEach((item) => {
        if (item.type_flag === "2") {
          item.product_name = "수금액";
          if (item.collect_way_flag == "2") {
            item.size = this.getBankAccountName(item.account_id);
          } else {
            item.size = this.system.options.resolve_collect_way_flag(
              item.collect_way_flag
            );
          }
          if (item.discount_price > 0) {
            item.unit_name = "DC";
            item.cost = item.discount_price;
          }
          item.price = item.collect_price;
          item.transaction_flag = item.collect_transaction_flag;
          collect_price += item.price;
          discount_price += item.discount_price;
        } else {
          item.transaction_flag = item.sale_transaction_flag;
          expense_price += item.price;
          tax_price += item.tax;
        }
      });
      // 월별 소계 추가
      let month_old = "";
      let month_cur = "";
      let month_supply_price = 0;
      let month_pyung = 0;
      let month_item_processing_cost = 0;
      let month_tax = 0;
      let month_price = 0;
      let month_amount = 0;
      // 기간누계 추가
      let total_supply_price = 0;
      let total_pyung = 0;
      let total_item_processing_cost = 0;
      let total_tax = 0;
      let total_price = 0;
      let total_amount = 0;
      // 품목계 추가
      let item_product_stat = {};
      this.product_stat.forEach((s) => {
        item_product_stat[s.id] = 0;
      });
      for (let i = 0; i < items.length; i++) {
        let item = items[i];
        month_cur = item.deal_date.substring(0, 7);
        if (month_old !== month_cur) {
          if (month_old !== "") {
            items.splice(i, 0, {
              sum_row: true,
              contract_code: "소 계",
              item_pyung: this.isTotalPyung ? month_pyung.toFixed(2) : '',
              amount: month_amount,
              supply_price: month_supply_price,
              item_processing_cost: month_item_processing_cost,
              tax: month_tax,
              price: month_price,
            });
            month_amount = 0;
            month_supply_price = 0;
            month_pyung = 0;
            month_item_processing_cost = 0;
            month_tax = 0;
            month_price = 0;
            i++;
          }
          month_old = month_cur;
        }
        if (item.type_flag === "1") {
          month_supply_price += item.supply_price;
          month_pyung += Number(this.isGlass(item,item.size)) * item.amount;
          month_item_processing_cost += item.item_processing_cost;
          month_tax += item.tax;
          month_price += item.price;
          month_amount += item.amount;
          total_supply_price += item.supply_price;
          total_pyung += Number(this.isGlass(item,item.size)) * item.amount;
          total_item_processing_cost += item.item_processing_cost
          total_tax += item.tax;
          total_price += item.price;
          total_amount += item.amount;
        }

        let product_id = item["product_id"];
        let product = this.table_product.find(
          (product_item) => product_item.id === product_id
        );
        // 제품 통계를 업데이트
        if (product) {
          this.product_stat.forEach((product_stat_item) => {
            let listCategory = this.getProductCategories(product.categories);
            if (
              product_stat_item.categories.every(
                (category_item) => listCategory.indexOf(category_item) > -1
              )
            ) {
              item_product_stat[product_stat_item.id] += item["amount"];
            }
          });
        }
      }
      if (items.length > 0 && !items[items.length - 1].sum_row) {
        //마지막 행이 소계가 아니라면
        items.splice(items.length + 1, 0, {
          sum_row: true,
          contract_code: "소 계",
          item_pyung: this.isTotalPyung ? month_pyung.toFixed(2) : '',
          amount: month_amount,
          supply_price: month_supply_price,
          item_processing_cost: month_item_processing_cost,
          tax: month_tax,
          price: month_price,
        });
      }
      // 기간누계 추가
      items.splice(items.length + 2, 0, {
        sum_row: true,
        total_sum: true,
        contract_code: "기간 누계",
        product_name: this.getProductStat(item_product_stat),
        amount: total_amount,
        supply_price: total_supply_price,
        item_pyung: this.isTotalPyung ? total_pyung.toFixed(2) : '',
        item_processing_cost: total_item_processing_cost,
        tax: total_tax,
        price: total_price,
      });
      //상단에 전기미수금 추가
      let last = { id: -1, product_name: "전 기 미 수 금", type_flag: "3" };
      last.balance = this.last_trade ? this.last_trade.balance : 0;
      items.splice(0, 0, last);

      this.collect_price = collect_price;
      this.discount_price = discount_price;
      this.expense_price = expense_price;
      this.tax_price = tax_price;
      this.items = items;
      if (!is_autoselect) {
        return;
      }
      this.$nextTick(() => {
        let items = this.items.filter(
          (item) => item.transaction_flag && item.transaction_flag !== "Y"
        );
        if (items.length < 1) {
          return;
        }
        this.$refs.table.toggleRowSelection(items, true);
      });
    },
    selectable(row) {
      return !!row.type_flag;
    },
    handleChangePeriod(period) {
      if (!period.valid) return;
      this.period = period;
      this.loadData();
    },
    handleRowClassName({ row }) {
      if (row.type_flag === "2") {
        return "collect-row";
      } else if (row.total_sum) {
        return "warning-row";
      } else if (row.sum_row) {
        return "sum-row";
      }
      return "";
    },
    handleSelectionChange(selection) {
      this.selection = selection;
      let ids = this.selection.map((s) => s.id);
      let data = this.$refs.table.data.filter((item) => ids.includes(item.id));
      this.selectedData = data;
    },
    handleClickTradePrint() {
      //상단에 전기미수금 삭제
      let items = Object.assign([], this.selectedData);
      if (items[0].type_flag === "3") items.splice(0, 1);
      this.selectedDataTradePrint = items;
      this.dialog_visible = true;
    },
    handleClickListPrint() {
      //상단에 전기미수금 수정
      if (this.selectedData[0].type_flag === "3") {
        if (this.selectedData.length === 1) {
          this.selectedData[0].balance = this.last_trade
            ? this.last_trade.balance
            : 0;
        } else {
          this.selectedData[0].balance =
            this.selectedData[1].balance +
            this.selectedData[1].expense -
            this.selectedData[1].income;
        }
      }
      this.dialog2_visible = true;
    },
    handleCompletedTradePrint(result) {
      this.dialog_visible = false;
      if (!result) {
        return;
      }
      this.loadData();
    },
    handleCompletedListPrint(result) {
      this.dialog2_visible = false;
      if (!result) {
        return;
      }
      this.loadData();
    },
    handleClickExcel() {
      this.$refs.table.downloadExcel();
    },
    getProductCategories(categories) {
      let ret = [];
      categories.forEach((c) => {
        ret.push(c.product_category_id);
      });
      return ret;
    },
    getProductStat(product_stat) {
      let ret = "";
      this.product_stat.forEach((s) => {
        ret += s.label + ":" + product_stat[s.id] + " ";
      });
      return ret;
    },
    handleSpanMethod({ row, columnIndex }) {
      if (row.sum_row) {
        switch (columnIndex) {
          case 3:
            return { rowspan: 1, colspan: 2 };
          case 4:
            // case 5:
            return { rowspan: 0, colspan: 0 };
        }
      }
    },
    isGlass(row) {
      if(row.pyung) return row.pyung
      let value = row.size;
      if (row.product_kind === "GLASS" && value) {
        if (value.includes("/")) value = value.split("/")[0];
        const [horizontal, vertical] = value.split("*").map((x) => Number(x));
        const return_value = this.util.calculatePyung(horizontal, vertical, true)
        return isNaN(return_value) ? "" : return_value < 3 ? 3 : return_value;
      }
      return "";
    },
    isGlassTotalPyung(row) {
      if(row.item_pyung) return row.item_pyung
      let value = row.size;
      if (row.product_kind === "GLASS" && value) {
        if (value.includes("/")) value = value.split("/")[0];
        const [horizontal, vertical] = value.split("*").map((x) => Number(x));
        let return_value = this.util.calculatePyung(horizontal, vertical, true)
        return isNaN(return_value) ? "" : ((return_value < 3 ? 3 : return_value) * row.amount).toFixed(2);
      }
      return "";
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/css/_variables.scss";

.IncomeLedger {
  .balance {
    color: $color-primary !important;
  }
  .el-table__row.collect-row {
    .product_name,
    .unit_name,
    .cost,
    .suppoy_price,
    .price {
      color: $color-danger;
    }
  }
  .el-table__row.sum-row {
    background: lightgray;
  }
  .el-table__row.warning-row {
    height: 30px;
  }
}
</style>
